import React from 'react';
import propTypes from 'prop-types';

const SubmitButton = ({ children, ...htmlProps }) => (
  <button type="submit" className="cmp-cta-link" {...htmlProps}>
    <span>{children}</span>
  </button>
);

SubmitButton.propTypes = {
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node,
  ]),
};

export { SubmitButton };
